import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

export interface AppTableProps {
    /** Header row(s) - pass TableRow(s) with TableCell children */
    head: React.ReactNode;
    /** Body content - pass TableRow(s) */
    children: React.ReactNode;
    /** When true, shows empty state row instead of children */
    isEmpty?: boolean;
    /** ColSpan for empty state cell */
    emptyColSpan?: number;
    /** Message shown when isEmpty */
    emptyMessage?: string;
    /** Sticky header on scroll */
    stickyHeader?: boolean;
    /** Optional class for TableContainer */
    className?: string;
    /** Optional sx for the inner Table element */
    tableSx?: object;
}

const defaultEmptyMessage = 'No Data Available';

export const AppTable: React.FC<AppTableProps> = ({
    head,
    children,
    isEmpty = false,
    emptyColSpan = 6,
    emptyMessage = defaultEmptyMessage,
    stickyHeader = false,
    className = '',
    tableSx,
}) => {
    return (
        <TableContainer component={Paper} className={`!shadow-sm !border !border-gray-200 ${className}`.trim()}>
            <Table stickyHeader={stickyHeader} sx={tableSx}>
                <TableHead>
                    {head}
                </TableHead>
                <TableBody>
                    {isEmpty ? (
                        <TableRow>
                            <TableCell colSpan={emptyColSpan} align="center" className="!py-12">
                                <div className="flex flex-col items-center">
                                    <div className="text-4xl mb-4">📄</div>
                                    <h3 className="text-lg font-medium text-gray-700">{emptyMessage}</h3>
                                </div>
                            </TableCell>
                        </TableRow>
                    ) : (
                        children
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default AppTable;
